import dayjs from "dayjs";

const preorder = {
    computed: {
        preorder() {
            return this.info.preOrder || {};
        },
        displayDeliveryDate() {
            return dayjs.unix(this.preorder.deliveryDate).format("MMM DD") || undefined;
        },
    },
};
export default preorder;
